import { em } from 'polished'
import styled, { css } from 'styled-components'

export const Cover = styled.div`
  background: ${p => p.theme.colors.catskillWhite};
  display: ${p => (p.isTablet ? 'none' : 'block')};
  height: 100%;
  position: absolute;
  ${p =>
    p.isTablet
      ? css`
          width: 59vw;
          left: 0;
        `
      : css`
          width: 90%;
          right: 0;
        `}

  ${p => p.theme.mq.upMd} {
    display: ${p => (p.isTablet ? 'block' : 'none')};
  }

  ${p => p.theme.mq.upLg} {
    width: 60%;
  }
`

export const Content = styled.div`
  min-height: 0;
  display: flex;
  align-items: center;

  ${p => p.theme.mq.upMd} {
    min-height: ${p => p.theme.blocks.heightMinResultsMd};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${p => p.theme.blocks.heightMinResultsLg};
  }
`

export const FrameWrapper = styled.div`
  position: relative;
  min-height: ${p => p.theme.blocks.heightMinResults};

  ${p => p.theme.mq.upMd} {
    overflow: hidden;
    width: 59vw;
    margin-left: ${em(-40)};
    padding-left: ${em(40)};
  }

  ${p => p.theme.mq.upLg} {
    width: auto;
    margin-left: 0;
    padding-left: 0;
  }
`

export const IconWrapper = styled.img`
  display: block;
  position: absolute;
  z-index: 4;
  -webkit-backface-visibility: hidden;

  &.bread {
    width: ${em(140)};
    top: -10%;
    left: 22%;

    ${p => p.theme.mq.upMd} {
      top: -15%;
      left: 30%;
      width: ${em(173)};
    }

    ${p => p.theme.mq.upLg} {
      top: 12%;
      left: 47%;
    }
  }

  &.potion {
    width: ${em(150)};
    bottom: 0;
    left: 3%;

    ${p => p.theme.mq.upMd} {
      width: ${em(173)};
      left: 15%;
      bottom: -10%;
    }
  }
`
